<div [style.width]="getSizeStyle()" class="loader"></div>
